// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color } from "@conklin/XDL/Utilities";
import { variantSwatchDropdownStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantSwatchDropdown";
import { css } from "styled-components";

variantSwatchDropdownStyles.labelText = {
    variant: "h6",
    weight: fontConfig.weight.regular,
    css: css`
        margin-bottom: 4px;
    `,
};

variantSwatchDropdownStyles.dropdown = {
    cssOverrides: {
        dropdownWrapper: css`
            margin-bottom: 12px;
        `,
    },
};
